import client from "../httpClient";
import dispatcher from "../dispatcher";

const deviceManagementService = {
  AddDeviceTags: () => {
    return client.Put("fleetManagement", ["fleetManagement"], {}, {});
  },
  GetDevices: () => {
    const  response =  client.Get(
      "fleetManagement",
      ["fleetManagement"],
      {},
      { staleTime: 6000 * 30 , cacheTime: 0}
    );
    if (response.isSuccess) {

      return {
        ...response,


      };
    } else {

      return { ...response, data: [] };
    }
  },
  ping:(system_id:any)=> {
     const res = client.Get(
      "ping",
      ["ping", system_id],
      { system_id },
      { staleTime: 0, cacheTime: 0, refetchInterval: 60000 }
    );
    return res;
  },
};

export default deviceManagementService;
